export const timestampTimeZone = 'Asia/Seoul';

const timestampDateFormatter = new Intl.DateTimeFormat('sv-SE', {
  timeZone: timestampTimeZone,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// 시각이 있는 API 값을 한국 날짜로 표시한다. 날짜 전용 값에는 사용하지 않는다.
export function formatTimestampDateKey(value?: string) {
  if (!value) return '';
  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return '';
  return timestampDateFormatter.format(instant);
}

export function formatTimestampDate(value?: string) {
  return formatTimestampDateKey(value).replaceAll('-', '.') || '-';
}
